import { Drawer, DrawerProps } from 'antd';

import { useResourceRoutePreview } from '@/shared/components/resource-route-preview/context';

/** The same task detail body can be presented in a drawer or the read-only Inbox portal. */
const TaskDetailFrame = ({ children, ...props }: DrawerProps) => {
    const preview = useResourceRoutePreview();
    return preview ? (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflow: 'hidden' }}>
            {children}
        </div>
    ) : (
        <Drawer {...props}>{children}</Drawer>
    );
};

export default TaskDetailFrame;
